import Layout from '@layouts/Layout';
import HelpCenter from '@screens/HelpCenter';

import React, { memo } from 'react';

const title = 'Help center';
const description = 'Questions about Traqq time tracker, how to install and implement it in your business? Find answers in the Traqq Help Center!';

export const getStaticProps = async () => {
    const res = await fetch(`${ process.env.NEXT_PUBLIC_APP_URL }/api/v1/support-v2`);

    if(res.status !== 200)
        return { notFound: true };

    const data = await res.json();

    return {
        props: { categories: data },

        revalidate: 60*60*24 // In seconds
    };
};

const HelpCenterPage = ({ categories }) => (
    <Layout
        title={ title }
        description={ description }
    >
        <HelpCenter
            categories={ categories }
        />
    </Layout>
);

export default memo(HelpCenterPage);
